// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__33UKN","buttons":"PendingPaymentAlert_buttons__3iE4f"};